import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import green from '@material-ui/core/colors/green'

import Button from 'components/CustomButtons/Button.jsx'

const styles = theme => ({
  root: {
    display: 'inline-block'
  },
  wrapper: {
    margin: theme.spacing.unit,
    position: "relative"
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  }
});

class CircularLoadingButton extends React.Component {
  render() {
    const { loading, btnContent, buttonProps, classes } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.wrapper}>
          <Button
            round
            variant="contained"
            disabled={loading}
            {...buttonProps}
          >
            {btnContent}
          </Button>
          {loading && (
            <CircularProgress size={24} className={classes.buttonProgress} />
          )}
        </div>
      </div>
    );
  }
}

CircularLoadingButton.propTypes = {
  classes: PropTypes.object.isRequired,
  buttonProps: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired
};

export default withStyles(styles)(CircularLoadingButton);


// WEBPACK FOOTER //
// ./src/views/Components/CircularLoadingButton.jsx